import { mapGetters, mapActions } from 'vuex'
import * as pbi from 'powerbi-client'

export const getPBIToken = {
  methods: {
    async getPBIToken(reportId) {
      try {

        await this.setPBIToken(reportId)       
        var pbiReport = this.getPBITokenList.find(x => x.report_id === reportId)       

        var embedConfiguration = {
          type: 'report',
          permissions: pbi.models.Permissions.Read,
          viewMode: pbi.models.ViewMode.View,
          id: pbiReport.pbi_report_id,
          pageName: pbiReport.pbi_page_name,
          embedUrl: 'https://app.powerbi.com/reportEmbed',
          tokenType: pbi.models.TokenType.Embed,
          accessToken: pbiReport.pbi_token,
          pageName: 'Data',
          settings: {
            background: pbi.models.BackgroundType.Transparent,
            layoutType: pbi.models.LayoutType.Master, //Master, Custom, MobilePortrait, MobileLandscape
            customLayout: {
              pageSize: {
                type: pbi.models.PageSizeType.Custom, //Widescreen, Standard, Cortana, Letter, Custom
                width: 900,
                height: 800
              },
              displayOption: pbi.models.DisplayOption.FitToPage //FitToPage, FitToWidth, ActualSize
            },
            panes: {
              filters: {
                visible: false
              },
              pageNavigation: {
                visible: true
              }
            }
          }
        }

        var report = powerbi.embed(this.$refs.reportContainer, embedConfiguration)
        
      } catch (error) {

      }
    },
    ...mapActions([
      'setPBIToken'
		])
  },
  computed: {
    ...mapGetters([
      'getPBITokenList'
    ])
  }
}